import { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom"
import ThemeToggle from "components/ThemeToggle"

const navItems = [
  { label: "Work", url: "/projects", external: false },
  { label: "Media", url: "/media", external: false },
]

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [hidden, setHidden] = useState(false)
  const lastY = useRef(0)
  const location = useLocation()

  const isActive = (url: string) => !url.startsWith("http") && location.pathname.startsWith(url)

  // Auto-hide on scroll-down, reveal on scroll-up, so the art owns the screen.
  useEffect(() => {
    lastY.current = window.scrollY
    let ticking = false
    const onScroll = () => {
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(() => {
        const y = window.scrollY
        if (y < 96) setHidden(false)
        else if (y > lastY.current + 6) setHidden(true)
        else if (y < lastY.current - 6) setHidden(false)
        lastY.current = y
        ticking = false
      })
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <>
      <header
        className={`sticky top-0 z-50 bg-gallery-bg/90 backdrop-blur border-b border-gallery-border transition-transform duration-300 ${
          hidden && !mobileOpen ? "-translate-y-full" : "translate-y-0"
        }`}
      >
        <div className="gallery-container">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex-shrink-0" aria-label="r4v3n home">
              <img src="/media/logo.png" alt="r4v3n" className="site-logo h-8 w-auto" />
            </a>

            <nav className="hidden md:flex items-center gap-8">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.url}
                  target={item.external ? "_blank" : "_self"}
                  rel={item.external ? "noopener noreferrer" : undefined}
                  aria-current={isActive(item.url) ? "page" : undefined}
                  className={`gallery-label nav-link ${isActive(item.url) ? "nav-link-active" : ""}`}
                >
                  {item.label}
                </a>
              ))}
            </nav>

            <div className="flex items-center gap-2 md:gap-3">
              <ThemeToggle />
              <button
                className="md:hidden p-1 text-gallery-muted hover:text-gallery-text"
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="Toggle menu"
                aria-expanded={mobileOpen}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {mobileOpen
                    ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12"/>
                    : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 8h16M4 16h16"/>
                  }
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-gallery-bg pt-16" onClick={() => setMobileOpen(false)}>
          <nav className="gallery-container py-8 flex flex-col gap-6">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.url}
                target={item.external ? "_blank" : "_self"}
                rel={item.external ? "noopener noreferrer" : undefined}
                className="font-serif text-2xl text-gallery-text"
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </>
  )
}

export default Header
